// extracted by mini-css-extract-plugin
module.exports = {"image_container":"TileImage_image_container__Iv1Mk","updateCursor":"TileImage_updateCursor__PDaBt"};